import { ReactNode } from 'react';
import revealStyle from './Reveal.module.scss';
import { useReveal } from '../../../hooks/useReveal';

interface IProps {
    children: ReactNode;
    /** Stagger in milliseconds. */
    delay?: number;
    className?: string;
}

const Reveal = (props: IProps) => {
    const { children, delay = 0, className = '' } = props;
    const { ref, isVisible } = useReveal<HTMLDivElement>();

    return (
        <div
            ref={ref}
            className={`${revealStyle.reveal} ${isVisible ? revealStyle.visible : ''} ${className}`}
            style={{ transitionDelay: `${delay}ms` }}
        >
            {children}
        </div>
    );
};

export default Reveal;
